import {
  Box,
  Button,
  TextField,
  InputAdornment,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import CustomFilterTabs from "../../../../Components/CustomFilterTabs";
import headerStyles from "../../styles/styles";
import MultiSelectDropdown from "../../../../Components/CustomDropdowns/MultiSelectDropdown";
import { useTranslation } from "react-i18next";

const SuppliersHeader = (props) => {
  const {
    activeTab,
    setActiveTab,
    searchValue,
    setSearchValue,
    categories,
    supplierStats,
    clearFilters,
    hasFilters,
    selectedCategories,
    setSelectedCategories,
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const { clearButtonStyles, mainContainer, textField } = headerStyles;
  const { t } = useTranslation("page-my-suppliers");

  return (
    <Box sx={mainContainer}>
      <CustomFilterTabs
        tabs={[
          {
            label: t("page_tabs.active_suppliers"),
            count: supplierStats.activeSuppliersStat,
            value: 1,
          },
          {
            label: t("page_tabs.join_requests"),
            count: supplierStats.requestsStat,
            value: 2,
          },
          {
            label: t("page_tabs.sent_invites"),
            count: supplierStats.invitesStat,
            value: 3,
          },
        ]}
        activeTab={activeTab}
        onChange={handleTabChange}
      />
      <Box
        display="flex"
        alignItems="center"
        gap="16px"
        sx={{
          flexWrap: { xs: "wrap", sm: "nowrap" },
        }}
      >
        <TextField
          value={searchValue}
          onChange={(e) => {
            const value = e.target.value;
            setSearchValue(value);
          }}
          variant="outlined"
          placeholder={t("search")}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: searchValue && (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => {
                    setSearchValue("");
                  }}
                  size="small"
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={textField}
        />
        <Box sx={{ position: "relative" }}>
          <MultiSelectDropdown
            value={selectedCategories}
            onChange={setSelectedCategories}
            options={categories.map((category) => ({
              value: category.id,
              label: category.name,
            }))}
            placeholder={t("filter_categories.no_filter")}
            buttonIconPath="/icons/filter-icon.svg"
            sx={{
              button: {
                minWidth: "220px",
                backgroundColor: "#fff",
                "&:hover": {
                  borderColor: "rgba(36, 139, 112, 1)",
                  backgroundColor: "#fff",
                },
              },
              menuPaper: {
                width: isMobile ? "100%" : "auto",
                maxWidth: isMobile ? "calc(100% - 24px)" : "300px",
              },
            }}
          />
        </Box>

        <Box
          sx={{
            cursor: hasFilters ? "pointer" : "not-allowed",
          }}
        >
          <Button
            onClick={clearFilters}
            sx={{
              pointerEvents: hasFilters ? "auto" : "none",
              ...clearButtonStyles,
            }}
          >
            {t("filter_categories.clear_filters")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SuppliersHeader;
